import { AddRoleFormDataType } from '../components/role/RoleForm'

export const AddRoleData: AddRoleFormDataType = {
  name: '',
  description: '',
}
